import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import TeamController from './team.controller';
import Page from '../common/page/Page';
import SplitLayout from '../common/layouts/splitLayout/SplitLayout';
import ActiveTeamCard from './elements/ActiveTeamCard';
import InviteTeamMembersCard from './elements/InviteTeamMembersCard';
import RolePermissionsCard from './elements/RolePermissionsCard';
import { SCOPES } from '../../constants/scopes.constants';
import { SplitLayoutVariant } from '../common/layouts/splitLayout/splitLayout.constants';
import styles from './styles/team.module.scss';

/**
 * Team component
 * @extends {TeamController}
 * @extends {Component}
 */
class Team extends Inherit(TeamController, Component) {
    render() {
        const {
            loading,
            fiRoles,
            users,
            usersPageInfo,
            newMemberEmail,
            newMemberRole,
            inviteLoading,
            usersListLoading,
            inviteError,
        } = this.state;

        const canManage = this.canManageTeam;
        const canInvite = this.canInvite;

        return (
            <Page
                isLoading={loading}
                scope={SCOPES.TEAM_VIEW}
                title={{ text: 'Team', highlight: 'Management' }}
                description="Manage your team members, roles, and permissions."
                notificationContextHolder={this.props.notificationContextHolder}
            >
                <SplitLayout
                    key='team'
                    variant={SplitLayoutVariant.TWO_THIRDS}
                    embedded
                    className={styles.splitRoot}
                    contentClassName={styles.splitContent}
                    sideClassName={styles.splitSide}
                    side={
                        <>
                            {canInvite ? (
                                <InviteTeamMembersCard
                                    email={newMemberEmail}
                                    role={newMemberRole}
                                    roleOptions={this.getAssignableRoles()}
                                    loading={inviteLoading}
                                    errorMessage={inviteError}
                                    onEmailChange={(value) => this.setNewMemberEmail(value)}
                                    onRoleChange={(value) => this.setNewMemberRole(value)}
                                    onSubmit={(e) => this.handleInviteSubmit(e)}
                                />
                            ) : null}
                            <RolePermissionsCard roles={fiRoles} />
                        </>
                    }>
                    <ActiveTeamCard
                        users={users}
                        loading={usersListLoading}
                        pageInfo={usersPageInfo}
                        canChangeRole={this.canChangeUserRole}
                        canResendInvitation={canManage}
                        canResetPassword={this.canResetPassword}
                        canRemoveAccess={this.canRemoveAccess}
                        roleOptions={this.getAssignableRoles()}
                        onTableChange={this.handleUsersTableChange.bind(this)}
                        getRole={(u) => this.getUserRole(u)}
                        getStatus={(u) => this.getUserStatus(u)}
                        formatLastActivity={(u) => this.formatLastActivity(u)}
                        onResetPassword={(email) => this.handleSendPasswordReset(email)}
                        onRemoveAccess={(userId, isCurrentlyActive) => this.handleDeleteUser(userId, isCurrentlyActive)}
                        onChangeRole={(userId, roleId) => this.handleChangeRole(userId, roleId)}
                        onResendInvitation={(email, roleId) => this.handleResendInvitation(email, roleId)}
                    />
                </SplitLayout>
            </Page>
        );
    }
}

export default withHooks(Team);
